<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="tool-content">
        <notice-bar />
        <h1 class="tool-title">YouTube・Twtichコメント欄用CSS</h1>

        <div class="comment-list">
            <div @click="openModal('fukidashi')" class="comment-preview">
              <img :src="carousel[1].src" class="comment-contents">
              <h2 class="comment-name">ふきだし(左)</h2>
            </div>
            <div @click="openModal('refukidashi')" class="comment-preview">
              <img :src="carousel[2].src" class="comment-contents">
              <h2 class="comment-name">ふきだし(右)</h2>
            </div>
            <div @click="openModal('v2fukidashi')" class="comment-preview">
              <img :src="carousel[0].src" class="comment-contents">
              <h2 class="comment-name">ふきだし v2</h2>
            </div>
            <div @click="openModal('simpleComment')" class="comment-preview">
              <img :src="carousel[3].src" class="comment-contents">
              <h2 class="comment-name">シンプル</h2>
            </div>
            <div @click="openModal('shadowTxtComment')" class="comment-preview">
              <img :src="carousel[4].src" class="comment-contents">
              <h2 class="comment-name">ふちどり</h2>
            </div>
            <div @click="openModal('midashi1Comment')" class="comment-preview">
              <img :src="carousel[5].src" class="comment-contents">
              <h2 class="comment-name">見出しつき</h2>
            </div>
        </div>

        <!-- モーダルの表示 -->
        <div v-if="showModal" class="modal" @click="closeModal">
          <div class="modal-content" @click.stop>
            <span class="close" @click="closeModal">&times;</span>
            <component :is="currentComponent" />
          </div>
        </div>

        <h1 class="tool-premium-title">プレミアムコメント欄</h1>
        <p class="tool-premium-description">有料でハイクオリティなコメント欄CSSもあります</p>

        <div class="comment-list">
            <div @click="openPremiumModal(12)" class="comment-preview">
              <img :src="carousel[12].src" class="comment-contents">
              <h2 class="comment-name">夜空</h2>
            </div>
            <div @click="openPremiumModal(6)" class="comment-preview">
              <img :src="carousel[6].src" class="comment-contents">
              <h2 class="comment-name">肉球 v2</h2>
            </div>
            <div @click="openPremiumModal(7)" class="comment-preview">
              <img :src="carousel[7].src" class="comment-contents">
              <h2 class="comment-name">ハート</h2>
            </div>
            <div @click="openPremiumModal(8)" class="comment-preview">
              <img :src="carousel[8].src" class="comment-contents">
              <h2 class="comment-name">プレミアムふきだし</h2>
            </div>
            <div @click="openPremiumModal(9)" class="comment-preview">
              <img :src="carousel[9].src" class="comment-contents">
              <h2 class="comment-name">グリッチ</h2>
            </div>
            <div @click="openPremiumModal(10)" class="comment-preview">
              <img :src="carousel[10].src" class="comment-contents">
              <h2 class="comment-name">半透明</h2>
            </div>
            <div @click="openPremiumModal(11)" class="comment-preview">
              <img :src="carousel[11].src" class="comment-contents">
              <h2 class="comment-name">肉球</h2>
            </div>
        </div>

        <!-- モーダルの表示 -->
        <div v-if="showPremiumModal" class="modal" @click="closePremiumModal">
          <div class="premium-modal-content" @click.stop>
            <span class="close" @click="closePremiumModal">&times;</span>
            <div class="premium-modal-main">
              <h3>{{ carousel[currentCarouselIndex].title }}</h3>
              <p>{{ carousel[currentCarouselIndex].description }}</p>
              <img :src="carousel[currentCarouselIndex].thum" alt="Modal Image">
              <div class="btn-area">
                <a :href="carousel[currentCarouselIndex].store" target="_blank">
                    <span class="store-btn">BOOTHで購入</span>
                </a>
                <router-link :to="carousel[currentCarouselIndex].to">
                    <span class="custom-btn">カスタマイズ</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="blog-area">
          <h2 class="blog-area-title">使い方はブログでチェック！</h2>
          <div class="blog-area-row">
            <div class="blog-area-thumb">
              <img class="article-list-img" src="@/assets/article/thumbnail_css_comment.png">
            </div>
            <div class="blog-area-desc">
              <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
              <div class="blog-area-btn">
                <a href="https://www.ruri.info/?p=221" target="_blank" rel="noopener noreferrer">
                  <span class="check-btn">記事をチェック</span>
                </a>
              </div>
            </div>
          </div>
        </div>
          <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
          <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"

import v2fukidashi from "../components/tw-frame-fukidashi.vue"
import fukidashi from "../components/comment/fukidashiComment.vue"
import refukidashi from "../components/comment/refukidashiComment.vue"
import simpleComment from '../components/comment/simpleComment.vue'
import shadowTxtComment from '../components/comment/shadowTxtComment.vue'
import midashi1Comment from '../components/comment/midashi1Comment.vue'

export default{
    components:{
      sidebar,
      noticeBar,
      v2fukidashi,
      fukidashi,
      refukidashi,
      secondHeader,
      simpleComment,
      shadowTxtComment,
      midashi1Comment,
    },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
        showModal: false,
        showPremiumModal: false,
        currentComponent: null,
        currentCarouselIndex: null,
        carousel:[
          {
            index: 1,
            src: require("@/assets/carousel/v2fukidashi.png")
          },
          {
            index: 2,
            src: require("@/assets/carousel/fukidashi.png")
          },
          {
            index: 3,
            src: require("@/assets/carousel/refukidashi.png")
          },
          {
            index: 4,
            src: require("@/assets/carousel/simpleComment.png")
          },
          {
            index: 5,
            src: require("@/assets/carousel/shadowTxtComment.png")
          },
          {
            index: 6,
            src: require("@/assets/carousel/midashi1Comment.png")
          },
          {
            index: 7,
            src: require("@/assets/carousel/nikukyu-comment.png"),
            thum: require("@/assets/thumbnail/premium-cat.png"),
            store:"https://takatsukisyou.booth.pm/items/5181357",
            title: "肉球コメント v2",
            to: "/premium-nyan2",
            description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。",
          },
          {
            index: 8,
            src: require("@/assets/carousel/heart-comment.png"),
            thum: require("@/assets/thumbnail/premium-heart.png"),
            store:"https://takatsukisyou.booth.pm/items/5181364",
            title: "ハートコメント",
            to: "/premium-heart",
            description:"OBSで使えるコメント用のカスタムCSS。ハートがアクセントのデザインです",
          },
          {
            index: 9,
            src: require("@/assets/carousel/fukidashi-comment.png"),
            thum: require("@/assets/thumbnail/premium-fukidashi.png"),
            to: "/premium-fukidashi",
            store:"https://takatsukisyou.booth.pm/items/4863903",
            title: "プレミアムふきだしコメント",
            description:"OBSで使えるコメント用のカスタムCSS。無料版より作りこんだふきだしです。無料版との違いは、「改行時などのレイアウト崩れなし」「きれいなしっぽ」「アニメーション付き」「各サイトの最新の仕様に対応」です。",
          },
          {
            index: 10,
            src: require("@/assets/carousel/glitch-comment.png"),
            thum: require("@/assets/thumbnail/premium-glitch.png"),
            to: "/premium-nyan",
            store:"https://takatsukisyou.booth.pm/items/4919770",
            title: "プレミアムグリッチコメント",
            description:"OBSで使えるコメント用のカスタムCSS。グリッチっぽいアニメーションが特徴。小さなスペースにも使えるシンプルなデザインです。",
          },
          {
            index: 11,
            src: require("@/assets/carousel/toumei-comment.png"),
            thum: require("@/assets/thumbnail/premium-traslucent.png"),
            store:"https://takatsukisyou.booth.pm/items/5119454",
            title: "プレミアム半透明コメント",
            description:"OBSで使えるコメント用のカスタムCSS。半透明なふきだしでゲーム画面など、背景と合わせるのに向いています。YouTube・Twitch用とわんコメのテンプレートもあります。",
          },
          {
            index: 12,
            src: require("@/assets/carousel/nikukyu-2-comment.png"),
            thum: require("@/assets/thumbnail/premium-cat.png"),
            to: "/premium-nyan",
            store:"https://takatsukisyou.booth.pm/items/4856981",
            title: "肉球コメント",
            description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。カラーは3種類！",
          },
          {
            index: 13,
            src: require("@/assets/carousel/moon-comment.png"),
            thum: require("@/assets/thumbnail/premium-moon.png"),
            store:"https://takatsukisyou.booth.pm/items/5855015",
            title: "夜空コメント",
            description:"OBSで使えるコメント用のカスタムCSS。月と星がアクセントのデザインです。",
          },
        ]
      }
    },
    methods: {
      openModal(componentName) {
        this.currentComponent = componentName;
        this.showModal = true;
      },
      openPremiumModal(index) {
        this.currentCarouselIndex = index;
        this.showPremiumModal = true;
      },
      closeModal() {
        this.showModal = false;
      },
      closePremiumModal() {
        this.showPremiumModal = false;
      }
    }
}
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

.tool-content{
  margin: 36px auto 0 auto;
  max-width: 960px;
  width: 100%;
  padding: 30px;
}

.tool-content h1{
  text-align: center;
}


.tool-title{
  letter-spacing: 2px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
  font-size: 1.5rem;
  color:#212121;
  font-weight: bold;
}

.tool-premium-title{
  margin-top: 5rem;
  letter-spacing: 2px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
  font-size: 1.5rem;
  color:#212121;
  font-weight: bold;
}

.tool-premium-description{
  text-align: center;
}

.comment-list{
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-top:48px;
}


@media screen and (max-width: 600px) {
  .comment-list{
    display: block;
  }
}

.comment-contents{
  width: 100%;
  height: auto;
}

.comment-name{
  margin-top: 12px;
  letter-spacing: 2px;
  font-size: 1rem;
}

.comment-preview{
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.35);
  background-color: #fafaf9;
  cursor: pointer;
	transition: .3s;
  width: auto;
  height: auto;
  border-radius: 15px;
  padding: 16px 24px 8px 24px;
  text-align: center;
  margin: 12px auto;
}

.comment-preview:hover {
	box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
  text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 5vh auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 15px;
  width: 80%;

  max-width: 900px;
  min-height: 80vh;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}

.premium-modal-content{
  background-color: #fefefe;
  margin: 5vh auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 15px;
  width: 80%;

  max-width: 900px;
  min-height: 80vh;
  text-align: center;
}

.premium-modal-main{
 padding-top:10%;
}

.premium-modal-main h3{
  font-size: 1.5rem;
}
.premium-modal-content img {
  max-width:320px;
  margin: 0 auto;
  vertical-align: bottom;
  margin-top: 20px;
}
.card-img {
  object-fit: contain;
  height: auto;
  width: 30%;
}

.premium-modal-content a {
  text-decoration: none;
}

.store-btn {
  color: #fff;
  background-color: #eb6100;
  padding: 5px 16px;
  border-radius: 8px;
    letter-spacing: 1px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  margin-right:12px;
  margin-top:12px;
}
.store-btn:hover,
a.store-btn:hover {
  color: #fff;
  background: #f56500;
}

.custom-btn {
  color: #fff;
  background-color: #9CB4CC;
  padding: 5px 16px;
  border-radius: 8px;
    letter-spacing: 1px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  margin-right:12px;
  margin-top:12px;
}
.custom-btn:hover,
a.custom-btn:hover {
  color: #fff;
  background: #B2C8DF;
}
</style>